import {Component, OnDestroy, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {environment} from '../../../../../environments/environment';
import {IButton} from '../../../../shared/card/card.component';
import {ServiceRequest} from '../../../../back-office/Models/ServiceRequest';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ServiceRequestService} from '../../../Services/service-request.service';
import {TranslateService} from '@ngx-translate/core';
import {Helper} from '../../../../helpers/helper.service';
import {Product} from '../../../../back-office/Models/Product';
import {Option} from '../../../../back-office/Models/Option';
import {carpetOptionName, carpetRoleLabelKey, carpetSizeLabel} from '../../../../helpers/carpet-price';

@Component({
  selector: "app-dealer-view-service-request",
  templateUrl: "./view-service-request.component.html",
  styleUrls: ["./view-service-request.component.scss"],
  animations: [
    trigger("openClose", [
      state("true", style({ height: "*" })),
      state("false", style({ height: "0px" })),
      transition("false <=> true", animate("500ms ease")),
    ]),
  ],
})
export class DealerViewServiceRequestComponent implements OnInit, OnDestroy {
  public baseUrl = environment.apiUrl;
  public requestId: number;
  public moreButton: IButton;
  public showMore = false;
  public request: ServiceRequest = new ServiceRequest();

  private subscriptions: Subscription[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly requestService: ServiceRequestService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit() {
    this.showLessDetail();
    this.route.params.subscribe((params) => {
      if (Helper.isDefined(params["id"])) {
        this.requestId = params["id"];
        this.getRequestItem();
      }
    });
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe((serviceRequest) => {
        this.request = serviceRequest;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  /** Carpet roles, exposed for the template so it doesn't hardcode magic strings */
  public readonly CARPET_ROLE_SHAPE = Option.CARPET_ROLE_SHAPE;
  public readonly CARPET_ROLE_FINISHING = Option.CARPET_ROLE_FINISHING;
  public readonly CARPET_ROLE_COLOUR = Option.CARPET_ROLE_COLOUR;

  /** A rug has no fabric — same check the order screen uses (D9) */
  isRugProduct(productItem): boolean {
    return Product.isRug(productItem?.product);
  }

  rugOptionName(holder, carpetRole: string): string {
    return carpetOptionName(holder?.orderItemOptions, carpetRole);
  }

  carpetSizeLabel = carpetSizeLabel;
  carpetRoleLabelKey = carpetRoleLabelKey;

  showMoreDetail() {
    this.showMore = true;
    this.moreButton = {
      key: "moreDetails",
      btnName: this.translate.instant(
        "admin.service.request.view.less_details",
      ),
      method: "showLessDetail",
      btnCustomClass: "btn-default",
      btnIconAfter: "fa fa-arrow-up",
    };
  }

  showLessDetail() {
    this.showMore = false;
    this.moreButton = {
      key: "moreDetails",
      btnName: this.translate.instant(
        "admin.service.request.view.more_details",
      ),
      method: "showMoreDetail",
      btnCustomClass: "btn-default",
      btnIconAfter: "fa fa-arrow-right",
    };
  }

  getRequestItem() {
    this.requestService.fetchServiceRequestComplete(this.requestId);
  }

  calFunction(method: string) {
    this[method]();
  }

  getFontAwesomeIconFromMIME(mimeType) {
    const icon_classes = {
      // Media
      image: "fa-file-image-o",
      audio: "fa-file-audio-o",
      video: "fa-file-video-o",
      // Documents
      "application/pdf": "fa-file-pdf-o",
      "application/msword": "fa-file-word-o",
      "application/vnd.ms-word": "fa-file-word-o",
      "application/vnd.oasis.opendocument.text": "fa-file-word-o",
      "application/vnd.openxmlformats-officedocument.wordprocessingml":
        "fa-file-word-o",
      "application/vnd.ms-excel": "fa-file-excel-o",
      "application/vnd.openxmlformats-officedocument.spreadsheetml":
        "fa-file-excel-o",
      "application/vnd.oasis.opendocument.spreadsheet": "fa-file-excel-o",
      "application/vnd.ms-powerpoint": "fa-file-powerpoint-o",
      "application/vnd.openxmlformats-officedocument.presentationml":
        "fa-file-powerpoint-o",
      "application/vnd.oasis.opendocument.presentation": "fa-file-powerpoint-o",
      "text/plain": "fa-file-text-o",
      "text/html": "fa-file-code-o",
      "application/json": "fa-file-code-o",
      // Archives
      "application/gzip": "fa-file-archive-o",
      "application/zip": "fa-file-archive-o",
    };

    for (const key in icon_classes) {
      if (icon_classes.hasOwnProperty(key)) {
        if (mimeType.search(key) === 0) {
          return icon_classes[key];
        }
      } else {
        return "fa-file-o";
      }
    }
  }

}
